import React from "react";
import { Dialog, Spinner } from "@blueprintjs/core";
import { FilledButton, TextButton } from "../components/buttons-20250224T111359Z-001/buttons";

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure you want to proceed with",
  itemName = "",
  confirmText = "Confirm",
  confirmIntent = "primary",
  isSubmitting = false,
  submittingText = "Removing...",
  loadingIndicator = null,
  errorMessage = "",
  confirmDisabled = false,
}) => {
  return (
    <Dialog
      portalContainer={document.body}
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      canEscapeKeyClose={!isSubmitting}
      canOutsideClickClose={!isSubmitting}
    >
      <div className="bp3-dialog-body push-20-b push-20-t">
        <h3>
          {message}
          {itemName && (
            <>
              <strong>{itemName}</strong>
            </>
          )}
          ?
        </h3>
        {errorMessage && <div role="alert" className="bp3-callout bp3-intent-danger">{errorMessage}</div>}
      </div>

      <div
        className="bp3-dialog-footer"
        style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 8 }}
      >
        <div className="bp3-dialog-footer-actions" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <FilledButton
            intent={confirmIntent}
            onClick={onConfirm}
            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
            disabled={isSubmitting || confirmDisabled}
          >
            {isSubmitting && !loadingIndicator && <Spinner size={16} style={{ color: "#fff" }} />}
            {isSubmitting ? submittingText : confirmText}
          </FilledButton>
          <TextButton
            text="Cancel"
            onClick={onClose}
            disabled={isSubmitting}
          />
          {isSubmitting && loadingIndicator}
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
